import { Navigate } from 'react-router-dom'
import useCheckMobileScreen from '../hooks/useCheckMobileScreen'

const CheckForDevice = ({ children }: any) => {
    let isMobile = useCheckMobileScreen()
    const checkDeviceForMobile = isMobile
    return checkDeviceForMobile ? <>{children}</> : <Navigate to="/404" />
}
export default CheckForDevice
